export default __webpack_public_path__ + "static/media/chefhat.2944785a.png";